var scope_0 = require('/Users/erinwang/Documents/GitHub/portfolio-v3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6365e076bbada133f45d653c353a06c3.js').default;
var scope_1 = require('/Users/erinwang/Documents/GitHub/portfolio-v3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c78a1659843d7fb90d64edaafb6adb60.js').default;
var scope_2 = require('/Users/erinwang/Documents/GitHub/portfolio-v3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/Users/erinwang/Documents/GitHub/portfolio-v3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f74f7d991da14469b4e11c22de3890cb.js').default;
var scope_4 = require('/Users/erinwang/Documents/GitHub/portfolio-v3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fce3e838ab48e756326dd3731db57efc.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    